module.exports = __webpack_public_path__ + "static/assets/img/weekly_report.ac8c8555.svg";